import { toolQuery, useRetireToolMutation } from "@common/api/tools"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute("/_layout/tools/$toolId/retire")({
  component: RetireToolDialog,
})

function RetireToolDialog(): React.ReactElement {
  const { toolId } = Route.useParams()
  const { data: tool } = useSuspenseQuery(toolQuery({ tool_id: toolId }))
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const mutation = useRetireToolMutation()

  const close = () =>
    navigate({ to: "/tools/$toolId", params: { toolId }, search: true })

  const confirm = () =>
    mutation.mutate(
      { tool_id: toolId },
      {
        onSuccess: () => {
          showToast("Retired", `${tool.number} retired.`, "success")
          navigate({ to: "/tools", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Retire ${tool.number}?`}
      description="Retired tools keep their loan and calibration history and show under Show retired."
      action="Retire"
      pendingAction="Retiring…"
      pending={mutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
